import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { LOGO } from "@/lib/assets";
import { useLang } from "@/context/LanguageContext";
import { Mail, Phone, Instagram, MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const { t, lang } = useLang();
  const [s, setS] = useState({});
  useEffect(() => { axios.get(`${API}/site-settings`).then((r) => setS(r.data || {})).catch(() => {}); }, []);

  const slogan = (s[`slogan_${lang}`] && s[`slogan_${lang}`].trim()) || t.footer.tagline;
  const email = s.email || "islandcamps.asso@gmail.com";
  const instaHandle = s.instagram_handle || "@islandcamps.sbh";
  const instaUrl = s.instagram_url || `https://instagram.com/${instaHandle.replace("@", "")}`;

  return (
    <footer data-testid="site-footer" id="contact" className="bg-[#6f7d54] text-[#f7efe0]">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <img src={LOGO} alt="Association Island Camps – Saint-Barthélemy" className="h-14 w-auto mb-5" />
          <p className="font-script text-2xl text-[#e0b36a] mb-3" data-testid="footer-slogan">{slogan}</p>
          <p className="font-body text-[#f7efe0]/70 flex items-start gap-2 text-sm">
            <MapPin size={16} className="mt-0.5 shrink-0" />
            <span>
              Association Island Camps<br />
              {s.address_line1 || "Grand Cul-de-Sac"}<br />
              {s.address_line2 || "97133 Saint-Barthélemy"}
            </span>
          </p>
        </div>

        <div className="md:justify-self-center">
          <h4 className="font-head font-semibold text-[#e0b36a] mb-4">{t.footer.contact}</h4>
          <div className="space-y-3 font-body">
            <a href={instaUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-[#f7efe0]/85 hover:text-white flex items-center gap-2">
              <Instagram size={16} /> {instaHandle}
            </a>
            <a href={`mailto:${email}`} data-testid="footer-email" className="text-[#f7efe0]/85 hover:text-white flex items-center gap-2">
              <Mail size={16} /> {email}
            </a>
            {s.phone ? (
              <a href={`tel:${s.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="text-[#f7efe0]/85 hover:text-white flex items-center gap-2">
                <Phone size={16} /> {s.phone}
              </a>
            ) : null}
          </div>
        </div>

        <div className="md:justify-self-end flex flex-col gap-3">
          <Link to="/adhesion" data-testid="footer-member-btn" className="inline-flex justify-center items-center rounded-full bg-[#e07a5f] hover:bg-[#cf6a50] text-white font-bold px-6 py-3 transition-colors">
            {t.nav.member}
          </Link>
          <Link to="/reservation" data-testid="footer-book-btn" className="inline-flex justify-center items-center rounded-full border border-white/30 text-white font-bold px-6 py-3 hover:bg-white/10 transition-colors">
            {t.nav.book}
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 font-body text-[#f7efe0]/45 text-xs text-center space-y-1">
          <p data-testid="footer-legal">
            Association Island Camps · N° {s.reg_number || "W9J1003357"} · Créée le {s.creation_date || "6 octobre 2025"} · {s.authority || "Préfecture de Saint-Barthélemy et Saint-Martin"} · ACM {s.acm_code || "971ORG04-99"}
          </p>
          <p>© 2026 Association Island Camps – Saint-Barthélemy · {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
